(function () {

    class GoogleTagManagerTracking 
    {
        initialize (settings) {
            // console.log(`GoogleTagManagerTracking initializing with UAID: ${settings.UAID}`)
            // window.dataLayer = window.dataLayer || [];
            // function gtag() {
            //     dataLayer.push(arguments);
            // }
            // gtag('js', new Date());
            // gtag('config', settings.UAID);
            return Promise.resolve();
        }

        track (event, data)
        {
            // NOTE(Mølby): The code below assumes a single event trigger tag in tagmanager listening for an event named 'InteractionEvent'.
            // It will map category, label and action data to a generic event tag (That way we can just create the events from this file, instead of deal with individualized tag manager setups)
            // You can setup tag manager in 2 minutes by importing a json file. Talk to me (Thomas Mølby, theg@cadpeople.dk) about it.
            // The tag manager template export is available here in the repository: "touch-kit-boilerplate/docs/google-tag-manager-template.json"
            // You have to import it into to tag manager (administrator > import container) and update the "Google Analytics settings" variable with your own google analytics id.
    
            var tagManagerEventData = false;

            switch(event)
            {
                case touchKit.TrackingManager.events.CONTENT_CLICKED:
                    {
                        switch(data.type)
                        {
                            case 'PresenterStarted':
                            {
                                tagManagerEventData = {
                                    Category: 'Presenter',
                                    Label: 'Started',
                                    Action: data.info
                                }
                            }
                            break;

                            case 'PresenterSkipped':
                                {
                                    tagManagerEventData = {
                                        Category: 'Presenter',
                                        Label: 'Skipped',
                                        Action: data.info
                                    }
                                }
                                break;

                            case 'EmbededVideoStartedManually':
                                {
                                    tagManagerEventData = {
                                        Category: 'EmbededVideo',
                                        Label: 'StartedManually',
                                        Action: data.info
                                    }
                                }
                                break;

                            case 'externalLink':
                                {
                                    tagManagerEventData = {
                                        Category: 'ExternalLink',
                                        Label: 'Clicked',
                                        Action: data.data.url
                                    }
                                }
                                break;

                            case 'FullscreenVideo':
                                {
                                    tagManagerEventData = {
                                        Category: 'FullscreenVideo',
                                        Label: 'Opened',
                                        Action: data.data.video
                                    }
                                }
                                break;
                            
                            default:
                                console.warn('Unknown type of CONTENT_CLICKED event type: ', data.type, data);
                                // NOTE: Log the content components name + route
                                {
                                    tagManagerEventData = {
                                        Category: 'ContentClicked',
                                        Label: data.type,
                                        Action: data.route
                                    }
                                }
                                break;
                        }
                    }
                    break;

                case touchKit.TrackingManager.events.PAGE_VISIT:
                    {
                        // NOTE: Make route prettier
                        var route = touchKit.PageManager.breadCrumbsTitle(data.route);
    
                        // Content Har merer data vi kan gøre smukt *K*
                        if (event === touchKit.TrackingManager.events.CONTENT_CLICKED) {
                            route += `/${data.type}/${data.id}`;
                        }
    
                        tagManagerEventData = {
                            Category: 'PageVisit',
                            Label: 'PageVisit',
                            Action: route
                        }
                    }
                    break;

                default:
                    console.error('Unknown tracking event: ', event);
                    break;
            }

            // NOTE: Push event data to tagmanager
            if (typeof dataLayer == "undefined")
            {
                console.warn('Unable to push event to tag manager. Are the tagmanager script snippets missing?');
                return;
            }
            else if (tagManagerEventData)
            {
                dataLayer.push({
                    event: 'InteractionEvent',
                    Category: tagManagerEventData.Category,
                    Label: tagManagerEventData.Label,
                    Action: tagManagerEventData.Action
                });
            }
        }
    }

    touchKit.TrackingManager.registerStrategy("GoogleTagManagerTracking", () => {
        return new GoogleTagManagerTracking();
    });

}());